import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CreateDisplayRequest, DisplayDto } from '../../../../../api/gen';

@Component({
  selector: 'app-create-display-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule
  ],
  templateUrl: './create-display-form.component.html',
  styleUrl: './create-display-form.component.scss'
})
export class CreateDisplayFormComponent implements OnInit, OnChanges {
  @Input() isProcessing = false;
  @Input() display: DisplayDto | null = null;
  @Input() mode: 'create' | 'edit' = 'create';
  @Input() parkingSpaceId: string | null = null;
  @Input() deviceGroupId: string | null = null;
  @Output() saveDisplay = new EventEmitter<CreateDisplayRequest>();
  @Output() cancel = new EventEmitter<void>();

  displayForm!: FormGroup;

  constructor(private fb: FormBuilder) {
    this.initForm();
  }

  ngOnInit(): void { }

  generateGUID(): void {
    this.displayForm.patchValue({ deviceHardwareID: crypto.randomUUID() });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['display'] && this.displayForm) {
      if (this.display) {
        this.displayForm.patchValue({
          deviceName: this.display.deviceName || '',
          deviceDescription: this.display.deviceDescription || '',
          deviceHardwareID: this.display.deviceHardwareID || '',
          macAddress: this.display.macAddress || '',
          piDeviceId: this.display.piDeviceId || ''
        });
      } else {
        this.displayForm.reset({ deviceName: '', deviceDescription: '', deviceHardwareID: '', macAddress: '', piDeviceId: '' });
      }
    }
  }

  private initForm(): void {
    this.displayForm = this.fb.group({
      deviceName: ['', [Validators.required, Validators.minLength(2)]],
      deviceDescription: [''],
      deviceHardwareID: [''],
      macAddress: [''],
      piDeviceId: ['']
    });
  }

  onSubmit(): void {
    if (this.displayForm.valid) {
      const formValue = this.displayForm.value;
      const request: CreateDisplayRequest = {
        deviceName: formValue.deviceName,
        deviceDescription: formValue.deviceDescription || null,
        deviceHardwareID: formValue.deviceHardwareID || undefined,
        macAddress: formValue.macAddress || null,
        piDeviceId: formValue.piDeviceId || null,
        siteId: this.parkingSpaceId || null,
        gateId: this.deviceGroupId || null
      };
      this.saveDisplay.emit(request);
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }
}
